import { cn } from '@/shared/utils/cn';
import { USER_ROLE_COLORS, USER_ROLE_LABELS } from '../shared/echarts-config';

const TOGGLEABLE_ROLES = ['CARE_SEEKER', 'FINANCIAL_ADVISOR', 'SERVICE_PROVIDER'] as const;

type UserTypeTogglesProps = {
  activeTypes: string[];
  onChange: (types: string[]) => void;
};

export const UserTypeToggles = ({
  activeTypes,
  onChange,
}: UserTypeTogglesProps) => {
  const handleToggle = (role: string) => {
    const isActive = activeTypes.includes(role);

    if (isActive && activeTypes.length <= 1) return;

    const next = isActive
      ? activeTypes.filter((t) => t !== role)
      : [...activeTypes, role];

    onChange(next);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {TOGGLEABLE_ROLES.map((role) => {
        const isActive = activeTypes.includes(role);
        const color = USER_ROLE_COLORS[role];
        return (
          <button
            key={role}
            type="button"
            data-active={isActive}
            onClick={() => handleToggle(role)}
            className={cn(
              'inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-colors border',
              isActive
                ? 'text-white border-transparent'
                : 'text-gray-500 bg-white border-gray-200 hover:bg-gray-50',
            )}
            style={isActive ? { backgroundColor: color } : undefined}
          >
            <span
              className="h-2.5 w-2.5 rounded-full"
              style={{ backgroundColor: color, opacity: isActive ? 1 : 0.4 }}
            />
            {USER_ROLE_LABELS[role]}
          </button>
        );
      })}
    </div>
  );
};
